import { render } from "./EthereumProvider.vue?vue&type=template&id=725ae2b9&scoped=true"
import script from "./EthereumProvider.vue?vue&type=script&lang=js"
export * from "./EthereumProvider.vue?vue&type=script&lang=js"

import "./EthereumProvider.vue?vue&type=style&index=0&id=725ae2b9&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-725ae2b9"

export default script